import SideImage from "../../assets/images/webp/newStartHerePage/sideImageOne.webp";
import GooglePlay from "../../assets/images/webp/newStartHerePage/googlePlay.webp";
import AppleStore from "../../assets/images/webp/newStartHerePage/appleStore.webp";
import BottomLargeImg from "../../assets/images/jpeg/startPageLargeImg.jpeg";
import PointTwo from "../../assets/images/webp/newStartHerePage/pointTwo.webp";
import PointThree from "../../assets/images/webp/newStartHerePage/pointThree.webp";

import CONSTANTS from "../../utils/constants/CONSTANTS";

import "./index.scss";

const DownloadSection = () => {
  return (
    <div className="download-section">
      <div className="section-title">
        <div className="number">
          <img className="number-img" src={PointTwo} alt="" />
        </div>
        <div className="title">Download our app</div>
      </div>
      <div className="download-container">
        <div className="left">
          <span className="intro">Welcome to</span>
          <span className="heading">OMNI-ACTIVE FITNESS</span>
          <span className="details">Download our app and login to get access to our workout plans</span>
          <div className="buttons">
            <img src={GooglePlay} className="button" alt="Google play Icon" />
            <img src={AppleStore} className="button" alt="Apple Store Icon" />
          </div>
        </div>
        <img src={SideImage} className="image" alt="male with dumbel" />
      </div>
      <div className="section-three">
        <div className="number">
          <img className="number-img" src={PointThree} alt="" />
        </div>
        <div className="title">Start your fitness journey</div>
      </div>
      <div className="large-img">
        <img className="new-bottom-img" src={BottomLargeImg} alt="bottom large image" />
      </div>
    </div>
  );
};
export default DownloadSection;
